<template>
  <div id="work-centers-management-page">
    <Header></Header>
    <div v-if="loaded" class="work-centers-flow">
      <VueFlowy :chart="chart"></VueFlowy>
    </div>
    <div class="work-centers-table">
      <WorkCentersTable v-if="loaded" :workCenters="workCenters" @updated="reloadPage"></WorkCentersTable>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import { VueFlowy, FlowChart } from "vue-flowy";
import WorkCenter from "@/models/WorkCenter.js";
import WorkCentersTable from "@/components/production-planning/WorkCentersTable.vue";
import User from "@/models/User.js";

export default {
  name: "work-centers-management-page",

  components: {
    VueFlowy,
    Header,
    WorkCentersTable,
  },

  data() {
    return {
      user: new User(this.$session.get("user")),
      chart: new FlowChart(),
      loaded: true,
      workCenters: [],
    };
  },
  created() {
    if (this.user.type > 1) {
      this.$session.destroy();
      this.$router.push({ name: "login" });
      this.$router.go();
    }
    this.initialize();
  },
  methods: {
    reloadPage() {
      this.$router.go();
    },
    async initialize() {
      this.workCenters = await WorkCenter.loadCenters(true);
      this.drawDiagram();
      this.loaded = true;
    },
    drawDiagram() {
      const elements = [];
      this.workCenters.forEach((workCenter) => {
        const deleted = workCenter.deleted
          ? ` (${this.$t("work_centers_management_page.deleted")})`
          : "";
        const preperation = workCenter.preperation ? "*" : "";
        const element = this.chart.addElement(workCenter.id, {
          label: `${workCenter.description}${preperation}${deleted}`,
          workCenter: workCenter,
        });
        elements.push(element);
      });

      for (const element of elements) {
        const workCenter = element.options.workCenter;
        if(workCenter.deleted){
          continue;
        }
        for (const dependency of workCenter.dependencies) {
          const dependencyFrom = this.workCenters.find((workCenter) => {
            return workCenter.id === dependency.depends_on;
          });
          if (dependencyFrom.deleted) {
            continue;
          }
          const dependencyElement = elements.find((element) => {
            return element.options.workCenter.id === dependency.depends_on;
          });
          dependencyElement.leadsTo(element);
        }
      }
    },
  },
};
</script>

<style scoped>
.work-centers-flow {
  position: relative;
  width: calc(100% - 30px);
  left: 15px;
}
.work-centers-table {
  position: relative;
  left: 25%;
  top: 50px;
  width: 50%;
}
</style>